const batteryLevelConverter = (batteryPercent: any, maxLevelTime: any) => {
	batteryPercent = parseInt(batteryPercent);
	let hours = (batteryPercent / 100) * maxLevelTime * 60;
	let hour = Math.floor(hours / 60);
	let min = Math.round(hours % 60);
	return { hour: hour, min: min };
};

export default batteryLevelConverter;
